/* eslint-disable */
export default {
  cancel: 'Cancel',
  pmiChangeConfirmed: 'Change',
  pmiChangeConfirmTitle: 'Change Personal Meeting settings?',
  pmiChangeConfirmContext:
    'Changing these settings will affect all meetings that use your personal meeting ID or name, including those you’ve already scheduled',
  updatePassword: 'Update password',
} as const;

// @key: @#@"cancel"@#@ @source: @#@"Cancel"@#@
// @key: @#@"pmiChangeConfirmed"@#@ @source: @#@"Change"@#@
// @key: @#@"pmiChangeConfirmTitle"@#@ @source: @#@"Change Personal Meeting settings?"@#@
// @key: @#@"pmiChangeConfirmContext"@#@ @source: @#@"Changing these settings will affect all meetings that use your personal meeting ID or name, including those you've already scheduled"@#@
// @key: @#@"updatePassword"@#@ @source: @#@"Update password"@#@
